import firebaseDB from './firebase'

/* Intitialize the firestore database */
const firestoreDB = firebaseDB.firestore()
// if (window.location.hostname === 'localhost') {
//     console.log('CONNECTING TO FIRESTORE EMULATORS')
//     firestoreDB.settings({
//         host: 'localhost:8080',
//         ssl: false,
//     })
// } else {
firestoreDB.settings({})
//}

/* Export the firestore database */
export default firestoreDB
